export default __webpack_public_path__ + "img/kents-kickback.png";